function validateListener(sensor, intervalMs, onReading, onError) {
  if (![
    "accelerometer",
    "gyroscope",
    "magnetometer",
    "deviceMotion"
  ].includes(sensor)) throw new TypeError("Motion.addListener requires a supported sensor");
  if (!Number.isFinite(intervalMs) || intervalMs < 0 || intervalMs > 1e3) throw new RangeError("Motion.addListener intervalMs must be between 0 and 1000");
  if (typeof onReading !== "function" || typeof onError !== "function") throw new TypeError("Motion.addListener requires reading and error callbacks");
}
export {
  validateListener
};
//# sourceMappingURL=validate.js.map
